import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class HttpClientService {

  constructor(private httpClient: HttpClient, @Inject("baseurl") private baseurl: string) { }
  private Url(requestParameters: Partial<RequestParameters>) {
    return `${requestParameters.baseUrl ? requestParameters.baseUrl : this.baseurl}/${requestParameters.controller}${requestParameters.action ? `/${requestParameters.action}` : ""}`;

  }

  get<T>(requestParameters: Partial<RequestParameters>, id?: number | string): Observable<T> {
    let url: string = "";
    if (requestParameters.fullEndPoint)
      url = requestParameters.fullEndPoint;
    else
      url = `${this.Url(requestParameters)}${id ? `/${id}` : ""}${requestParameters.queryString ? `?${requestParameters.queryString}` : ""}`;

    return this.httpClient.get<T>(url, {
      headers: requestParameters.headars,

    });
  }
  post<T>(requestParameters: Partial<RequestParameters>, body: Partial<T>): Observable<T> {
    let url: string = "";
    if (requestParameters.fullEndPoint)
      url = requestParameters.fullEndPoint;
    else
      url = `${this.Url(requestParameters)}${requestParameters.queryString ? `?${requestParameters.queryString}` : ""}`;

    return this.httpClient.post<T>(url, body, {
      headers: requestParameters.headars,
    });
  }
  put<T>(requestParameters: Partial<RequestParameters>, body: Partial<T>): Observable<T> {
    let url: string = "";
    if (requestParameters.fullEndPoint)
      url = requestParameters.fullEndPoint;
    else
      url = `${this.Url(requestParameters)}${requestParameters.queryString ? `?${requestParameters.queryString}` : ""}`;
    return this.httpClient.put<T>(url, body, {
      headers: requestParameters.headars,
    });
  }
  delete<T>(requestParameters: Partial<RequestParameters>, id?: number): Observable<T> {
    let url: string = "";
    if (requestParameters.fullEndPoint)
      url = requestParameters.fullEndPoint;
    else
      url = `${this.Url(requestParameters)}/${id}${requestParameters.queryString ? `?${requestParameters.queryString}` : ""}`;
    return this.httpClient.delete<T>(url, {
      headers: requestParameters.headars,
    });
  }
}

export class RequestParameters {
  controller?: ControllerType;
  action?: string;
  queryString?: string;

  headars: HttpHeaders;
  baseUrl?: string;
  fullEndPoint?: string
}

export enum ControllerType {
  Auth = "Auths",
  User = "Users",
  Role = "Roles",
  ApplicationService = "ApplicationServices",
  AuthorizationEndpoint = "AuthorizationEndpoints",
  Company = "Companies",
  Kind = "Kinds",
  Currency = "Currencies",
  Category = "Categories",
  CompanyLabel = "CompanyLabels",
  UnitType = "UnitTypes",
  Tax = "Taxes",
  Warehouse = "Warehouses",
  Product = "Products",
  ProductSerial = "ProductSerials",
  ProductMovement = "ProductMovements",
  SubProduct = "SubProducts",
  ProductLabel = "ProductLabels",
  TransactionManagement = "TransactionManagements",
  TransactionManagementDescription = "TransactionManagementDescription",
  TransactionProduct = "TransactionProducts",
  TransactionProductDescription = "TransactionProductDescriptions",
  Project = "Projects",
  QuoteCode = "QuoteCodes",
  Page = "Pages",
  PageUser = "PageUsers",
  Vault = "Vaults",
  CompanyVaultMovement = "CompanyVaultMovements",
  VaultVaultMovement = "VaultVaultMovements",
  RequestTask = "RequestTasks",
  Pdf = "Pdfs",
  Person = "Persons",
  Action = "Actions",
  Expense = "Expenses",
  Brand = "Brands",
  BrandModel = "BrandModels",
  MainExpense = "MainExpenses",
  PersonMovement = "PersonMovements",
  PersonLeave = "PersonLeaves",
  Payroll = "Payrolls",
  PersonPoint = "PersonPoints",
  Device = "Devices",
  DeviceMovement = "DeviceMovements",
  Dashboard = "Dashboards",
  Deneme = "Deneme",
  TransactionAdditionalFeature = "TransactionAdditionalFeatures",
  Reference = "References",
  DeliveryMethod = "DeliveryMethods",
  DeviceAcceptanceStates = "DeviceAcceptanceStates",
  Procedure = "Procedures",
  EnvironmentalCondition = "EnvironmentalCondition",
  DeviceClass = "DeviceClasses",
  Delivery = "Deliveries",
  DeliveryDevice = "DeliveryDevices",
  Calibration = "Calibrations",
  ReferenceDeviceMovement = "ReferenceDeviceMovements",
  CalibraitonReferenceDevice = "CalibrationReferenceDevices",
  Certificate = "Certificates",
  CertificateReservation = "CertificateReservations",
  Province = "Provinces"
}